import React from "react";
import "./ddd.css";

function DDDUI({ imageUrl, onBack, onLogoClick, hideBackButton, hideHeader, children }) {
  return (
    <>
      {!hideHeader && (
      <header className="upperaction">
        <img
          src={imageUrl}
          alt="Header"
          className="logo-holder"
          onClick={onLogoClick}
          style={{ cursor: "pointer" }}
        />
        {!hideBackButton && (
          <div className="back-holder">
            <button onClick={onBack} className="back-default">Back</button>
          </div>
        )}
       
      </header>
      )}
      {children}
    </>
  );
}

export default DDDUI;